import { render, staticRenderFns } from "./AnnotationModule.vue?vue&type=template&id=270a189a&scoped=true&"
import script from "./AnnotationModule.vue?vue&type=script&lang=js&"
export * from "./AnnotationModule.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationModule.vue?vue&type=style&index=0&id=270a189a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270a189a",
  null
  
)

export default component.exports